import type { BoardStatus } from '../types';

export const mockBoardStatuses: BoardStatus[] = [
  {
    id: 'bs-1',
    boardId: 'board-1',
    name: 'To Do',
    color: 'cyan-glacier',
    type: 'Todo',
    order: 0,
    wipLimit: null,
  },
  {
    id: 'bs-2',
    boardId: 'board-1',
    name: 'In Progress',
    color: 'indigo-vortex',
    type: 'InProgress',
    order: 1,
    wipLimit: 5,
  },
  {
    id: 'bs-3',
    boardId: 'board-1',
    name: 'Review',
    color: 'pink-flamingo',
    type: 'InProgress',
    order: 2,
    wipLimit: 3,
  },
  {
    id: 'bs-4',
    boardId: 'board-1',
    name: 'Done',
    color: 'green-emerald',
    type: 'Done',
    order: 3,
    wipLimit: null,
  },
];
